import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showModal: false,
  contentModal: undefined,
  toast: {
    isOk: true,
    show: false,
    messages: "",
  },
  screenLoading: false,
  token: sessionStorage.getItem("token") || undefined,
};

export const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers: {
    toggleSreenLoading: (state) => {
      state.screenLoading = !state.screenLoading;
    },
    toggleShowModal: (state) => {
      state.showModal = !state.showModal;
    },
    turnOffShowModal: (state) => {
      state.showModal = false;
      state.spinnerLoading = false;
    },
    setContentModal: (state, action) => {
      const { contentModal } = action.payload;
      state.contentModal = contentModal;
    },
    turnOffToast: (state) => {
      state.toast.show = false;
      state.toast.messages = "";
    },
    setToastOk: (state, action) => {
      const { isOk, messages } = action.payload;
      state.toast.isOk = isOk;
      state.toast.show = true;
      state.toast.messages = messages;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const {
  toggleShowModal,
  setContentModal,
  turnOffShowModal,
  turnOffToast,
  setToastOk,
  toggleSreenLoading,
  setToken,
} = mainSlice.actions;

export default mainSlice.reducer;
